import { styled } from '@mui/material';
import { Typography } from '../../../../../components/atoms/Typography';

export const RepairLabourTime = styled(Typography)`
  margin-top: 10px;
`;